module.exports = __webpack_public_path__ + "img/skd-folded-offline-light.ef3aac87.svg";